import { render, staticRenderFns } from "./noticeList.vue?vue&type=template&id=4ea9d3f4&scoped=true"
import script from "./noticeList.vue?vue&type=script&lang=js"
export * from "./noticeList.vue?vue&type=script&lang=js"
import style0 from "./noticeList.vue?vue&type=style&index=0&id=4ea9d3f4&prod&lang=scss&scoped=true"
import style1 from "./noticeList.vue?vue&type=style&index=1&id=4ea9d3f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea9d3f4",
  null
  
)

export default component.exports